<template>
  <div class="location_wrap">
    <div class="location">
      <span>{{ currentRouteGroup.groupNm || '' }}</span>
      <span class="svg_next">></span>
      <div v-on-clickaway="closeListMenu" class="current">
        <div class="select_area">
          <div class="select_item" :class="{ active: showListMenu }">
            <button type="button" class="select_option" @click="toggleListMenu">
              <span class="txt">{{ currentRouteName }}</span
              ><span class="arrow blind">열기</span>
            </button>
            <ul v-if="currentRouteGroup" class="select_list">
              <li
                v-for="(d, i) in currentRouteGroup.group"
                :key="i + `location`"
              >
                <router-link :to="{ name: d.pageRouteName }">{{
                  d.locationName
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    currentGroupName: {
      type: String,
      default: 'serviceCenter'
      // required: true
    }
  },
  data() {
    return {
      showListMenu: false,
      locationGroup: [
        {
          groupCd: 'onlyTeacher',
          groupNm: '교강사 전용',
          group: [
            {
              pageRouteName: 'postPresent',
              locationName: '증정 코드입력'
            },
            {
              pageRouteName: 'present',
              locationName: '증정요청'
            }
          ]
        },
        {
          groupCd: 'serviceCenter',
          groupNm: this.$t('views.help.events.7922'),
          group: [
            {
              pageRouteName: 'faq',
              locationName: this.$t('common.footer.7188')
            },
            {
              pageRouteName: 'events',
              locationName: this.$t('views.help.events.5625')
            },
            {
              pageRouteName: 'notices',
              locationName: this.$t('views.help.events.9277')
            },
            {
              pageRouteName: 'newsletters',
              locationName: '뉴스레터'
            }
          ]
        },
        {
          groupCd: 'information',
          groupNm: this.$t('views.help.sitemap.8839'),
          group: [
            {
              pageRouteName: 'sitemap',
              locationName: this.$t('views.help.sitemap.560')
            },
            {
              pageRouteName: 'guide',
              locationName: this.$t('views.help.sitemap.6225')
            },
            {
              pageRouteName: 'terms',
              locationName: this.$t('views.help.sitemap.4763')
            },
            {
              pageRouteName: 'privacy',
              locationName: this.$t('views.help.sitemap.6772')
            }
          ]
        }
      ]
    }
  },
  computed: {
    currentRouteName() {
      return this.allLocationGroup.find(
        (e) => e.pageRouteName === this.$route.name
      ).locationName
    },
    currentRouteGroup() {
      return this.locationGroup.find((e) => {
        return e.groupCd === this.currentGroupName
      })
    },
    allLocationGroup() {
      // return this.locationGroup.reduce((x, y) => {
      //   return [...x.group, ...y.group]
      // })
      return this.locationGroup.reduce((x, y) => {
        return [...x, ...y.group]
      }, [])
    }
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  }
}
</script>
<style lang="scss" scoped></style>
